export default "__VITE_ASSET__SATQQ87t__"